import { createReducer } from "@reduxjs/toolkit";
import { studentRetrievePendingActions } from "./retrieve-student-pending-actions";
import type { StudentPendingActionsVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<StudentPendingActionsVM> = {
  fetching: "idle",
  data: {
    hasActions: false,
    attendanceSheets: { pendingCount: 0 },
    surveys: { pendingCount: 0 },
    objectives: { pendingCount: 0 },
  },
};

export const studentPendingActionsRetrievalReducer = createReducer<RetrievalState<StudentPendingActionsVM>>(initialState, builder => {
  builder.addCase(studentRetrievePendingActions.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(studentRetrievePendingActions.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(studentRetrievePendingActions.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
